import React from 'react';
import { ProcessingIcon } from './icons/IconProvider';

const ButtonLoader = ({ title }) => {
  return (
    <div className="flex items-center gap-2">
      <ProcessingIcon />
      {title}
    </div>
  );
};

export default ButtonLoader;
